<% if (Anvil.page.modal.issue.link == 'database' || Anvil.page.modal.issue.link == 'site' || Anvil.page.modal.issue.link == 'terminal' || Anvil.page.modal.issue.link == 'aee') { %>
<%- include('/ui/form', {
	params: [ 'issue_link_database', Anvil.page.modal.issue ],
	fields: [
		{
			type: 'select',
			name: 'company_db_id',
			title: 'Adatbázis',
			params: {
				maxItems: 1,
				options: Anvil.page.modal.company_dbs.data.filter(x => x.company_id == Anvil.page.modal.issue.company_id),
				valueField: 'id',
				labelField: 'db_name',
				searchField: [ 'db_name' ],
				render: {
					item: (item, esc) => `<div>${esc(item.db_name)}</div>`,
					option: (item, esc) => `<div class="option">${esc(item.db_name)}</div>`
				}
			},
			unset_value: null,
			attributes: Anvil.page.modal.issue.closed ? { disabled: 'disabled' } : null,
			update: (value) => {

				// Reset values
				Anvil.page.modal.issue.site_id = null
				Anvil.page.modal.issue.terminal_id = null
				Anvil.page.modal.issue.aee_id = null

				// Re-render site picker
				Anvil.render('/issue/modal_edit_panel_link_site', {}, '#panel-link-site')
				// Re-render terminal picker
				Anvil.render('/issue/modal_edit_panel_link_terminal', {}, '#panel-link-terminal')
				// Re-render aee picker
				Anvil.render('/issue/modal_edit_panel_link_aee', {}, '#panel-link-aee')
			}
		}
	]
}) %>
<% } %>